import React, { Component } from 'react'
import PropTypes from 'prop-types'
import QuestListItem from './mini/QuestListItem'

export default class Quests extends Component {
  render() {
    const { dispatch, user } = this.props
    var quests = this.props.quests.map((quest, index) => {
      return (
        <QuestListItem
          quest={quest}
          key={index}
          dispatch={dispatch}
          user={user}
          navToSection={this.props.navToSection}
          iconHeightWidth={this.props.iconHeightWidth}
        />
      )
    })

    return <ul>{quests}</ul>
  }
}

Quests.propTypes = {
  quests: PropTypes.array,
  dispatch: PropTypes.func,
  user: PropTypes.object.isRequired,
  navToSection: PropTypes.string,
  iconHeightWidth: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Quests.js